<template>
  <DsfFormControlBox class="ds-system" :owner="_self">
    <template v-slot:simple>
      <DsfTextProxy v-model="value" v-bind="_self.$props"></DsfTextProxy>
    </template>
    <template v-slot:content>
      <template v-if="isDesign">
        [当前部门id]
      </template>
      <template v-else>
        {{ value }}
      </template>
    </template>
  </DsfFormControlBox>
</template>

<script>
export default dsf.component({
  name: "DsfDeptId",
  mixins: [$mixins.formControl],
  ctrlCaption: "当前部门id",
  props: {
    caption: {
      type: String,
      default: dsf.config.kw.deptid,
    },
    label: {
      type: String,
      default: "当前部门id",
    },
    simple: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    allowPost:{
      type:Boolean,
      default:false
    },
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("system-meta-data", {
          code: dsf.config.kw.deptid,
          valueAttributes: [
            {
              name: "当前部门id",
              code: dsf.config.kw.deptid,
              type: dsf.metadata.getDataType("string"),
              length: "50",
              defaultValue: null,
              unit: null,
            },
          ],
        });
      },
    },
    //设计器复制粘贴组件时不改变caption
    desCopyedChangeCaption:{
      type:Boolean,
      default:false
    },
  },
});
</script>
